export const FEATURE_NAME = "gate-control";
